import { render } from "./CHT_Top.vue?vue&type=template&id=c2be7faa"
import script from "./CHT_Top.vue?vue&type=script&lang=js"
export * from "./CHT_Top.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__